import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavigateNext = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 25,
	fill: "none",
	viewBox: "0 0 25 25",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#49454F",
		d: "m13.428 12.16-4.6-4.6 1.4-1.4 6 6-6 6-1.4-1.4 4.6-4.6Z"
	})
});
export { SvgNavigateNext as ReactComponent };
